import { render } from "./Repman.vue?vue&type=template&id=ba509df8&ts=true"
import script from "./Repman.vue?vue&type=script&lang=ts"
export * from "./Repman.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\wamp64\\www\\hayllissac\\sistema\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__